import { RoomType } from '@core/referential/room-type.enum'
import { UseCase } from '@core/referential/use-case.enum'
import { AirQualityMetricSchema } from '@shared/schema/site.air-quality-comfort-percentage.schema'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { timeRangeOptions } from '@/lib/date'
import { isUseCase } from '@/lib/utils'

import { SearchSchema as BaseSearchSchema } from '../-utils/search'

const defaultDateRange = {
  startDate: dayjs().subtract(7, 'day').toISOString(),
  endDate: dayjs().toISOString(),
}

export const SearchSchema = BaseSearchSchema.merge(
  z.object({
    startDate: z.string().default(defaultDateRange.startDate),
    endDate: z.string().default(defaultDateRange.endDate),
    timeRange: z.enum(timeRangeOptions).default('7d'),
    roomType: z.enum([RoomType.ROOM, RoomType.OFFICE, 'all']).default('all'),
    metric: AirQualityMetricSchema.default('co2'),
  }),
)

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/air-quality/conformity/')({
  validateSearch: SearchSchema,
  async beforeLoad() {
    if (!isUseCase(UseCase.AIR_QUALITY)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }
  },
  pendingComponent: PendingComponent,
})
